import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    zones: [],
    loading_zones: false,
    loading_zones_errors: null,
    zones_cancel_source: null,
    zoneproducts: [],
    loading_zoneproducts: false,
    loading_zoneproducts_errors: null,
    zoneproducts_cancel_source: null,
    zonesmap: [],
    loading_zonesmap: false,
    loading_zonesmap_errors: null,
    zonesmap_cancel_source: null,
    saving_zone: false,
};

const mutations = {
    updateZones(state, zones) {
        state.zones = zones;
    },
    updateSavingZone(state, saving_zone) {
        state.saving_zone = saving_zone;
    },
    updateLoadingZones(state, loading) {
        state.loading_zones = loading;
    },
    updateLoadingZonesErrors(state, errors) {
        state.loading_zones_errors = errors;
    },
    updateZoneProducts(state, zoneproducts) {
        state.zoneproducts = zoneproducts;
    },
    updateSavingZoneProduct(state, saving_zone) {
        state.saving_zone = saving_zone;
    },
    updateLoadingZoneProducts(state, loading) {
        state.loading_zoneproducts = loading;
    },
    updateLoadingZoneProductsErrors(state, errors) {
        state.loading_zoneproducts_errors = errors;
    },
    updateZonesMap(state, zonesmap) {
        state.zonesmap = zonesmap;
    },
    updateLoadingZonesMap(state, loading) {
        state.loading_zonesmap = loading;
    },
    updateLoadingZonesMapErrors(state, errors) {
        state.loading_zonesmap_errors = errors;
    },
    updateZonesCancelSource(state, cancel_source) {
        state.zones_cancel_source = cancel_source;
    },
    updateZoneProductsCancelSource(state, cancel_source) {
        state.zoneproducts_cancel_source = cancel_source;
    },
    updateZonesMapCancelSource(state, cancel_source) {
        state.zonesmap_cancel_source = cancel_source;
    },
};

const actions = {

    async fetchZoneProducts({ commit, dispatch, state }, params) {
        commit('updateLoadingZoneProducts', true);
        commit('updateLoadingZoneProductsErrors', null);

        if (state.zoneproducts_cancel_source) {
            state.zoneproducts_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateZoneProductsCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/zoneproducts/', {
                cancelToken: state.zoneproducts_cancel_source?.token
            });
            commit('updateLoadingZoneProducts', false);
            commit('updateZoneProducts', response.data);
            commit('updateZoneProductsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateLoadingZoneProductsErrors', error.details);
            commit('updateLoadingZoneProducts', false);
            throw error;
        }
    },

    async fetchZones({ commit, dispatch, state }, params) {
        commit('updateLoadingZones', true);
        commit('updateLoadingZonesErrors', null);

        if (state.zones_cancel_source) {
            state.zones_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateZonesCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/zones/', {
                params: { limit: 1000 },
                cancelToken: state.zones_cancel_source?.token
            });
            commit('updateLoadingZones', false);
            commit('updateZones', response.data.results);
            commit('updateZonesCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateLoadingZonesErrors', error.details);
            commit('updateLoadingZones', false);
            throw error;
        }
    },

    async fetchZonesMap({ commit, dispatch, state }, params) {
        commit('updateLoadingZonesMap', true);
        commit('updateLoadingZonesMapErrors', null);

        if (state.zonesmap_cancel_source) {
            state.zonesmap_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateZonesMapCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/zonesmap/', {
                cancelToken: state.zonesmap_cancel_source?.token
            });
            commit('updateLoadingZonesMap', false);
            commit('updateZonesMap', response.data);
            commit('updateZonesMapCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateLoadingZonesMapErrors', error.details);
            commit('updateLoadingZonesMap', false);
            throw error;
        }
    },

    async cloneZone({ commit, dispatch, state }, params) {
        try {
            const response = await axios.post(`/api/zones/${params.instance.id}/clone/`, params.instance);
            dispatch('fetchZonesMap');
            dispatch('fetchZones');
            dispatch('fetchZoneProducts');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async deleteZone({ commit, dispatch, state }, params) {
        commit('updateSavingZone', true);

        try {
            const response = await axios.delete(`/api/zones/${params.instance.id}/`, params.instance);
            dispatch('fetchZonesMap');
            dispatch('fetchZones');
            dispatch('fetchZoneProducts');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async saveZoneProduct({ commit, dispatch, state }, params) {
        commit('updateSavingZoneProduct', true);

        let url = '/api/zoneproducts/';
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/zoneproducts/${params.instance.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            commit('updateSavingZoneProduct', false);
            dispatch('fetchZonesMap');
            dispatch('fetchZones');
            dispatch('fetchZoneProducts');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateSavingZoneProduct', false);
            throw error;
        }
    },

    async saveZone({ commit, dispatch, state }, params) {
        commit('updateSavingZone', true);

        let url = '/api/zones/';
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/zones/${params.instance.id}/`;
            method = axios.put;
        }
        try {
            const response = await method(url, params.instance);
            commit('updateSavingZone', false);
            dispatch('fetchZonesMap');
            dispatch('fetchZones');
            dispatch('fetchZoneProducts');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateSavingZone', false);
            throw error;
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
